var _path, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContentRatingP = function SvgContentRatingP(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H18C19.6569 0 21 1.34315 21 3V18C21 19.6569 19.6569 21 18 21H3C1.34315 21 0 19.6569 0 18V3Z",
    fill: "#929497"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2284_11039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94283 10.6458C10.5165 10.6458 11.0204 10.5764 11.4544 10.4375C11.8957 10.2986 12.2598 10.1042 12.5466 9.85417C12.8409 9.59722 13.0615 9.28819 13.2086 8.92708C13.3557 8.56597 13.4293 8.16319 13.4293 7.71875C13.4293 7.28125 13.3557 6.88889 13.2086 6.54167C13.0689 6.19444 12.8556 5.8993 12.5687 5.65625C12.2818 5.41319 11.9178 5.22917 11.4764 5.10417C11.0425 4.97222 10.5313 4.90625 9.94283 4.90625H7.58175V10.6458H9.94283ZM9.94283 3C10.9799 3 11.8773 3.11458 12.6349 3.34375C13.3999 3.57292 14.0288 3.89583 14.5216 4.3125C15.0217 4.72222 15.3932 5.21875 15.6359 5.80208C15.8786 6.37847 16 7.01736 16 7.71875C16 8.43403 15.8713 9.09028 15.6138 9.6875C15.3564 10.2778 14.9739 10.7882 14.4664 11.2188C13.9589 11.6424 13.3263 11.9757 12.5687 12.2188C11.8185 12.4549 10.9432 12.5729 9.94283 12.5729H7.58175V18H5V3H9.94283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2284_11039",
    x: 3,
    y: 1,
    width: 15,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2284_11039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2284_11039",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContentRatingP, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/content_rating_p.f2d5d8ec.svg";
export { ForwardRef as ReactComponent };